// KundenverbindungSelect.tsx — ordnet den Kontakt einer BESTEHENDEN
// Kundenverbindung zu (reine Auswahl, kein Neuanlegen). Die Zuweisung erfolgt
// erst beim Speichern (PATCH contactGroupId, siehe persistRelations.assignKundenverbindung).

import * as React from "react";
import { LabeledSelect } from "../forms/formPrimitives";
import { apiUrl } from "../../utils/api";
import { useRelStyles } from "./styles";

type KvGroup = { id: number; name: string; memberCount?: number };

export function KundenverbindungSelect({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const s = useRelStyles();
  const [groups, setGroups] = React.useState<KvGroup[]>([]);

  React.useEffect(() => {
    fetch(apiUrl("contactgroup/kundenverbindungen"))
      .then((r) => r.json())
      .then((d) => setGroups(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  return (
    <>
      <p className={s.hint}>Diesen Kontakt einer bestehenden Kundenverbindung zuordnen (optional).</p>
      <LabeledSelect
        label="Kundenverbindung"
        name="rel-kv"
        value={value}
        onChange={onChange}
        options={groups.map((g) => ({
          value: String(g.id),
          label: g.memberCount != null ? `${g.name} (${g.memberCount})` : g.name,
        }))}
        placeholder="Keine"
      />
    </>
  );
}
